import ModalUnsavedChanges from './ModalUnsavedChanges'

export default ModalUnsavedChanges
// eslint-disable-next-line import/export
export * from './ModalUnsavedChanges'
